// THIS FILE IS AUTOMATICALLY GENERATED. DO NOT MODIFY IT MANUALLY.

import { THEME_NAME, THEME_MODE } from '../../../symbol';

import baseTheme from '../../trellis/light/theme';

export type ThemeName = 'warm-neutral';

export type ThemeMode = 'light';

/**
 * Design System theme object.
 *
 * Theme name: `warm-neutral`
 *
 * Theme mode: `light`
 */
const theme = {
  ...baseTheme,
  color: {
    ...baseTheme.color,
    'fwc-button-fill-primary-default': '#e74100',
  },
};

Object.assign(theme, {
  [THEME_NAME]: 'warm-neutral',
  [THEME_MODE]: 'light',
});

export default theme;
